import * as React from "react";

function SvgLiveImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09 0C1.527 0 0 1.526 0 3.09v27.82C0 32.473 1.526 34 3.09 34h27.82c1.564 0 3.09-1.526 3.09-3.09V3.09C34 1.527 32.474 0 30.91 0H3.09zm3.092 11.818a1 1 0 011-1h15a1 1 0 011 1v3.663l3.974-3.038c.294-.225.662.056.662.506v8.102c0 .45-.368.731-.662.506l-3.974-3.038v3.663a1 1 0 01-1 1h-15a1 1 0 01-1-1V11.818z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLiveImage;
